(function () {
  var state = window.FierroComboState || { station: null };
  window.FierroComboState = state;

  function requestedStation() {
    try {
      return new URL(window.location.href).searchParams.get('estacao');
    } catch (error) {
      return null;
    }
  }

  function availableStations() {
    return Array.prototype.slice
      .call(document.querySelectorAll('[data-fm-station-tab]'))
      .map(function (tab) {
        return tab.dataset.fmStationTab;
      });
  }

  function normalizeStation(key, fallback) {
    var available = availableStations();
    if (available.indexOf(key) !== -1) return key;
    if (available.indexOf(fallback) !== -1) return fallback;
    return available[0] || key || fallback || 'barn';
  }

  function updateSelectors(key) {
    document.querySelectorAll('[data-fm-combo-selector]').forEach(function (root) {
      root.querySelectorAll('[data-fm-station-tab]').forEach(function (tab) {
        var active = tab.dataset.fmStationTab === key;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-pressed', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });
    });
  }

  function updatePanels(key) {
    document.querySelectorAll('[data-fm-combo-listener]').forEach(function (root) {
      var panels = root.querySelectorAll('[data-fm-station-panel]');
      var matched = false;

      panels.forEach(function (panel) {
        var active = panel.dataset.fmStationPanel === key;
        panel.hidden = !active;
        if (active) matched = true;
      });

      if (!matched && panels.length) {
        panels[0].hidden = false;
      }
    });
  }

  function setStation(key, updateAddress) {
    var firstSelector = document.querySelector('[data-fm-combo-selector]');
    var fallback = firstSelector ? firstSelector.dataset.defaultStation : 'barn';
    var normalized = normalizeStation(key, fallback);

    state.station = normalized;
    updateSelectors(normalized);
    updatePanels(normalized);

    if (updateAddress && window.history && window.URL) {
      var address = new URL(window.location.href);
      address.searchParams.set('estacao', normalized);
      window.history.replaceState({}, '', address.toString());
    }

    document.dispatchEvent(
      new CustomEvent('fierro:combo-station-change', {
        detail: { station: normalized }
      })
    );
  }

  function setupSelector(root) {
    if (!root || root.dataset.fmComboReady === 'true') return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-fm-station-tab]'));
    if (!tabs.length) return;

    root.dataset.fmComboReady = 'true';

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        setStation(tab.dataset.fmStationTab, true);
      });

      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

        event.preventDefault();
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        var nextIndex = (index + direction + tabs.length) % tabs.length;
        tabs[nextIndex].focus();
        setStation(tabs[nextIndex].dataset.fmStationTab, true);
      });
    });
  }

  function initialize(scope) {
    var context = scope || document;

    if (context.matches && context.matches('[data-fm-combo-selector]')) {
      setupSelector(context);
    }

    if (context.querySelectorAll) {
      context.querySelectorAll('[data-fm-combo-selector]').forEach(setupSelector);
    }

    var selector = document.querySelector('[data-fm-combo-selector]');
    var fallback = selector ? selector.dataset.defaultStation : 'barn';
    var initial = state.station || requestedStation() || fallback;
    setStation(initial, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
